import { Box, Fade, Flex, Icon, IconButton, Text, Tooltip } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { MdErrorOutline, MdMenu } from 'react-icons/md';
import config from '../../../config';
import { DRAWER_WIDTH } from '../../../root-constants';
import { useDrawer } from '../../../state/drawer';
import { TitleContext } from '../../../state/title';
import useScroll from '../../../utils/hooks/scroll.hooks';
import BackButton from './BackButton';
import LanguagePicker from './LanguagePicker';
import NotificationsBell from './NotificationsBell';
import UserMenu from './UserMenu';

interface MainAppBarProps {}

const MainAppBar: React.FC<MainAppBarProps> = () => {
  const scroll = useScroll();
  const { onOpen: onOpenDrawer } = useDrawer();

  const [title] = useContext(TitleContext);

  return (
    <Flex
      as="header"
      direction="column"
      position="fixed"
      zIndex="1100"
      left="auto"
      top="0"
      right="0"
      w={{ base: '100%', lg: `calc(100% - ${DRAWER_WIDTH}px)` }}
      ml={{ base: 0, lg: DRAWER_WIDTH }}
      backgroundColor="white"
      boxShadow="0px 0px 14px 0px rgb(53 64 82 / 5%)"
      flexShrink={0}
      color="white"
      boxSizing="border-box"
    >
      <Flex justify="space-between" minH="54px" px="24px" position="relative" align="center">
        <Flex>
          <IconButton
            display={{ base: 'block', lg: 'none' }}
            variant="ghost"
            aria-label="toggle drawer"
            icon={<Icon color="black" fontSize={22} as={MdMenu} />}
            onClick={onOpenDrawer}
          />

          <BackButton />

          <Fade in={scroll.y >= 110}>
            <Flex h="100%" align="center" px="5px">
              <Text fontSize={16} color="black" ml="25px">
                {title}
              </Text>
            </Flex>
          </Fade>
        </Flex>

        <Flex align="center">
          {config.env !== 'production' && (
            <Tooltip label="Simulate error">
              <IconButton
              mr={2}
                variant="ghost"
                colorScheme="red"
                aria-label="simulate error"
                fontSize={22}
                icon={<MdErrorOutline />}
                onClick={() => {
                  throw new Error('fake-error');
                }}
              />
            </Tooltip>
          )}

          <div>
            <NotificationsBell />
          </div>

          <Box mr="30px" ml="18px">
            <LanguagePicker />
          </Box>

          <div>
            <UserMenu />
          </div>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MainAppBar;
